export const normalizeFileName = (text: string) =>
  text.normalize('NFKD').replace(/[^\w\s.-_/]/g, '')
